import Category from '@/models/Category';
import { ApplicationState } from '@/store';
import React, { CSSProperties, MouseEventHandler } from 'react';
import { useSelector } from 'react-redux';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import CategoryItem from './components/CategoryItem';
import './style.scss';

interface PreviousArrowProps {
    onClick?: MouseEventHandler;
    className?: string;
    style?: CSSProperties;
}

function PreviousArrow(props: PreviousArrowProps) {
    const { className, style, onClick } = props;
    return (
        <div className={`${className} previous-arrow overlay`} onClick={onClick} style={{ ...style }}>
            <div className="arrow-container">
                <i className="material-icons outline">navigate_before</i>
            </div>
        </div>
    );
}

interface NextArrowProps {
    onClick?: MouseEventHandler;
    className?: string;
    style?: CSSProperties;
}

function NextArrow(props: NextArrowProps) {
    const { className, style, onClick } = props;
    return (
        <div className={`${className} next-arrow overlay`} onClick={onClick} style={{ ...style }}>
            <div className="arrow-container">
                <i className="material-icons outline">navigate_next</i>
            </div>
        </div>
    );
}

const CategorySectionTopBar: React.FC = () => {
    const {
        data: { categories },
    } = useSelector((state: ApplicationState) => state.categories);

    const getSlidesToShow = (): number => {
        let currentWidth: number = 0;
        let countItems: number = 0;
        const maxWidth: number = 1140;
        if (categories) {
            const averageCategorylength: number = categories.map((c: Category) => c.name).join('').length / categories.length;
            categories.forEach((c: Category) => {
                currentWidth += 64 + c.name.length * averageCategorylength;
                if (currentWidth < maxWidth) {
                    countItems++;
                }
            });
        }
        return countItems == 0 ? 1 : countItems;
    };

    const settings = {
        className: 'list',
        speed: 500,
        dots: false,
        infinite: true,
        slidesToShow: getSlidesToShow(),
        slidesToScroll: 1,
        variableWidth: true,
        arrows: true,
        draggable: false,
        prevArrow: <PreviousArrow />,
        nextArrow: <NextArrow />,
    };

    return (
        <div className={`category-section-top-bar ${categories && categories.length === settings.slidesToShow ? 'no-arrows' : ''}`}>
            {settings && settings.slidesToShow > 0 && categories && categories.length > 0 && (
                <Slider {...settings}>
                    {categories.map((item, index) => (
                        <CategoryItem categoryType={item} key={index} />
                    ))}
                </Slider>
            )}
        </div>
    );
};
export default CategorySectionTopBar;
